export const en_forcreators = {
  main1: "Making Monetization Much Easier Than Ever",
  sub1: "Ubiq has no monetization hurdles, and from the first post, you can receive advertising revenue in the form of a token called biq.",
  main2: "More information and possibilities for any kind of graphics you make",
  sub2: "Ubiq also reads the text information on the graphics you post, so you can expect web search traffic on the Ubiq Web version, hyperlinks on images and text, and other scalability that Instagram and Pinterest have not been able to achieve.",
}